module.exports = __webpack_public_path__ + "static/media/searchCity.b062ddda.svg";